import {
  Avatar,
  EAvatarSize,
  GeneralMenuIcon,
  GeneralUserUserIcon,
  RawButton,
} from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';

import { getUser } from '@/redux/selectors/auth/user';
import formatImageURL from '@/utility/formatImageURL';
import { getUserInitials } from '@/utility/getUserInitials';

import styles from './GlobalHeaderMenuTrigger.module.css';

type TGlobalHeaderMenuTriggerProps = {
  'aria-label'?: string;
  onClick?: () => void;
  showBurgerMenuIcon?: boolean;
  isOpen?: boolean;
};

export const GlobalHeaderMenuTrigger = forwardRef<HTMLButtonElement, TGlobalHeaderMenuTriggerProps>(
  function GlobalHeaderMenuTrigger(
    { 'aria-label': ariaLabel, onClick, showBurgerMenuIcon, isOpen },
    ref,
  ) {
    const user = useSelector(getUser);

    const hasNotification =
      !!user?.unread_conversations ||
      (user && (!user.verifications?.email || !user.verifications?.phone));

    return (
      <RawButton
        ref={ref}
        aria-label={ariaLabel}
        onPress={onClick}
        className={cn(styles.root, {
          [styles.open as string]: isOpen,
          [styles.guest as string]: !user,
        })}>
        {showBurgerMenuIcon && <GeneralMenuIcon fontSize={24} />}

        <span className="relative">
          <Avatar
            round
            size={EAvatarSize.Medium}
            imageUrl={
              user?.avatar_url ? formatImageURL(user.avatar_url, 'square80', 'fill') : undefined
            }
            initials={user ? getUserInitials(user.first_name, user.last_name) : undefined}
            defaultBrandIcon={user ? undefined : GeneralUserUserIcon}
            className={styles.avatar}
          />
          {hasNotification && <span className={styles.notification} aria-hidden />}
        </span>
      </RawButton>
    );
  },
);
